import React, {useState} from "react";
import {Affix, Col, Divider, Row, Space} from "antd";
import PremiumsInBoundGraph from "../../components/commercialDetail/PremiumsInBoundGraph";
import AnnualHitRatioGraph from "../../components/commercialDetail/AnnualHitRatioGraph";
import NegotiationsInBoundGraph from "../../components/commercialDetail/NegotiationsInBoundGraph";
import BudgetGroupsCards from "../../components/commercialDetail/BudgetGroupsCards";
import {useGetAllBudgetGroupsQuery} from "../../redux/api/budgetsApiSlice";
import {useBankBranchesChartsParamsContext} from "../../context/BankBranchesChartsContext";
import BankBranchesSubmissionRecevied
    from "../../components/commercialDetail/bankBranches/BankBranchesSubmissionRecevied";
import NegotiationsInBoundTotal from "../../components/commercialDetail/NegotiationsInBoundTotal";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import BankBranchesTableMap from "../../components/commercialDetail/bankBranches/BankBranchesTableMap";
import BBBChartColContainer from "../../components/commercialDetail/BBBChartColContainer";
import SearchBankBranch from "../../components/commercialDetail/bankBranch/SearchBankBranch";
import UwYearDatePicker from "../../components/select/UwYearDatePicker";
import {useSelector} from "react-redux";
import {selectUser} from "../../redux/features/userSlice";
import {skipToken} from "@reduxjs/toolkit/dist/query";

export default function BranchIndex() {

    const {params, setParams} = useBankBranchesChartsParamsContext()
    const uwYear = useSelector(selectUser).preferences?.charts_params?.uw_year
    const areParamsOk = typeof uwYear === 'number'
    const {
        data: budgetGroupOptions,
        isFetching: isFetchingBudgetGroupOptions
    } = useGetAllBudgetGroupsQuery(areParamsOk ? {
        entity: 1,
        uw_year: uwYear,
    } : skipToken)
    const [isAffix, setIsAffix] = useState(false)
    const {xs} = useBreakpoint()

    return <div style={{padding: xs ? 0 : "1rem"}}>
        <Affix
            offsetTop={0}
            onChange={a => setIsAffix(!!a)}>
            <Row
                style={isAffix ? {
                    padding: '16px',
                    borderRadius: '12px',
                    boxShadow: '0px 10px 15px -10px #AAAAAA',
                    backgroundColor: '#ffffff',
                } : {}}
                justify={"end"}
                align={"middle"}
                gutter={[16, 16]}>
                <Col
                    flex={1}
                    xs={isAffix ? 0 : undefined}
                >
                    <Space align={'center'}>
                        <h1>Dashboard Filiali</h1>
                        <SearchBankBranch/>
                    </Space>
                </Col>
                <Col>
                    <UwYearDatePicker/>
                </Col>
                <Col xs={24}>
                    <BudgetGroupsCards
                        loading={isFetchingBudgetGroupOptions}
                        options={budgetGroupOptions || []}
                        selectedOption={params.budget_group}
                        setSelectedOption={(value: string) => {
                            setParams(prevState => ({
                                ...prevState,
                                budget_group: value
                            }))
                        }}
                    />
                </Col>
            </Row>
        </Affix>
        <Divider/>
        <Row gutter={[16, 16]}>
            <BankBranchesTableMap/>
            <BBBChartColContainer>
                <PremiumsInBoundGraph entity={'bank_branch'}/>
            </BBBChartColContainer>
            <BBBChartColContainer>
                {areParamsOk && <AnnualHitRatioGraph
                    uw_year={uwYear}
                    entity={1}
                    budget_group={params.budget_group}
                />}
            </BBBChartColContainer>
            <BBBChartColContainer>
                <NegotiationsInBoundGraph entity={'bank_branch'}/>
            </BBBChartColContainer>
            <BBBChartColContainer>
                <BankBranchesSubmissionRecevied/>
            </BBBChartColContainer>
            <BBBChartColContainer>
                <NegotiationsInBoundTotal entity={'bank_branch'}/>
            </BBBChartColContainer>
        </Row>
    </div>
}